import { yupResolver } from '@hookform/resolvers/yup'
import { useMemo, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { type ProjectDomain } from '../../types/domain/project-domain'
import {
  generalSettingsStepSchema,
  timeStepSchema,
} from '../../validators/scheduleMeetSchema'
import { DialogModal } from '../DialogModal'
import { GeneralSettingsStep } from './components/GeneralSettingsStep'
import { TimeStep } from './components/TimeStep'

type Attendee = {
  id: number
  name: string
  email: string
}

export type DefaultValuesScheduleMeetForm = {
  experts: Attendee[]
  administrativeUsers: Attendee[]
  analysts: Attendee[]
  contacts: Attendee[]
  summary?: string
  description?: string | null
  date?: string
  startTime?: string
  endTime?: string
}

interface ScheduleMeetFormStepperProps {
  meetingId?: number
  project: ProjectDomain
  defaultValues?: DefaultValuesScheduleMeetForm
  taskId: number
  isOpen: boolean
  onClose: () => void
}

export const ScheduleMeetFormStepper = ({
  meetingId,
  taskId,
  defaultValues,
  project,
  isOpen,
  onClose,
}: ScheduleMeetFormStepperProps) => {
  const [currentStep, setCurrentStep] = useState<0 | 1>(0)

  const schema = useMemo(() => {
    if (currentStep === 0) {
      return generalSettingsStepSchema
    }

    return timeStepSchema
  }, [currentStep])

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues,
  })

  const handleGoToNextStep = () => {
    setCurrentStep(1)
  }

  const handleBackToPreviousStep = () => {
    setCurrentStep(0)
  }

  const title = meetingId ? 'Editar reunião' : 'Agendar reunião'

  return (
    <DialogModal
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      styleBox={{ maxWidth: currentStep === 0 ? '1280px' : '660px' }}
    >
      <FormProvider {...methods}>
        {currentStep === 0 && (
          <div className="px-4 py-6">
            <GeneralSettingsStep
              clientId={project.client?.id}
              onGoToNextStep={handleGoToNextStep}
            />
          </div>
        )}

        {currentStep === 1 && (
          <div className="px-6 pt-10 pb-6">
            <TimeStep
              meetingId={meetingId}
              taskId={taskId}
              onGoBackToPreviousStep={handleBackToPreviousStep}
              onSuccessfulSubmit={onClose}
              submitButtonText={title}
            />
          </div>
        )}
      </FormProvider>
    </DialogModal>
  )
}
